<div class="main-error-page" [class.banner-area]="hasBanner">

  <div class="error-content" >
    <div class="error-txt">
      <h1>{{error_header | translate}}</h1>
      <p class="sub-head">
        {{error_sub_heading_1 | translate}}
      </p>
      <p class="sub-head-2" *ngIf="error_sub_heading_2">
        {{error_sub_heading_2 | translate}}
      </p>
    </div>
    <div class="publish-btn" *ngIf="showTriggerGoToApp">
        <button class="publish-button" (click)="triggerGoToApp()" >
          <span>{{'CP_SM_GO_TO_APP' | translate}}</span>
           <ng-container *ngIf="showSpinner$">
            <div class="spin-in-btn">
                <div class="spinner-border spinner"></div>
            </div>
        </ng-container>
        </button>
      </div>
  </div>
  <div class="error-image">
    <picture>
      <source media="(min-width:1280px)" srcset="../../../../../assets/images/raceShare-error-landscape.png">
      <source media="(min-width:768px)" srcset="../../../../../assets/images/raceShare-error-tablet.png">
      <source media="(min-width:280px)" srcset="../../../../../assets/images/raceShare-error-portrait.png">
      <img src="../../../../../assets/images/raceShare-error-landscape.png" alt="error">
    </picture>
  </div>

</div>
